<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="descricao"> Descrição</label>
						<div class="col-sm-6">
							<textarea class="form-control" v-model="form.descricao" placeholder="Descrição" v-autosize></textarea>
						</div>
					</div>
					<div class="form-group">
						<select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'

export default {
	components: {
		PageHeader,
		FooterButton,
		SelectForm,
		VueElementLoading,
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Gestões',
			form: {
				descricao: '',
				ativo: '1',
			},
			isActiveBtn: false,
			isActive: false
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				await req(`/v1/gestoes/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/gestoes')
			} else {
				await req('/v1/gestoes', 'post', body).catch(() => {
					erro()
				})
				this.isActive = false
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/gestoes')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			await req('/versao/1', 'put', {
				title: Date.now()
			})
		},
		getDados() {
			req(`/v1/gestoes/${this.$route.params.id}`).then(resp => {
				this.form.ativo = resp.ativo
				this.form.descricao = resp.descricao
				this.isActive = false
			}).catch(() => {
				erro()
			})
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
